import { useMutation, useQuery } from 'react-query';
import { CompanyAPI } from '../api/company';
import { API } from '../services/api';
import { NotificationsResponse as NotificationsResponseLegacy } from '../types/notifications';
import { NotificationsAPI } from '../api/notification';
import { NotificationSettingsAPI } from 'services/notification-settigs';

interface ListProps {
  size: number;
  page: number;
}
export const useNotificationsQuery = (params: ListProps) => {
  const { size, page } = params;
  return useQuery<
    { message: string },
    { error: { message: string } },
    NotificationsResponseLegacy
  >(
    ['get-notifications-list', size, page],
    async () => await API.getter(CompanyAPI.notifications(params)),
    {
      staleTime: 10 * 1000,
      refetchOnWindowFocus: 'always',
    },
  );
};
enum NotificationChannels {
  EMAIL = 'email',
  PORTAL = 'portal',
  SMS = 'sms',
}

interface NotificationsResponse {
  // each module is a key in response
  internetManagement: {
    // each event is key in module
    lineDown: NotificationsModuleEvents[];
    lineDownQuota: NotificationsModuleEvents[];
    lineUp: NotificationsModuleEvents[];
  };
  doorAccess: {
    doorDown: NotificationsModuleEvents[];
    doorUp: NotificationsModuleEvents[];
  };
}
interface NotificationsModuleEvents {
  id: string;
  module: string; // enum will be provided later
  event: string; // enum will be provided later
  channel: NotificationChannels; // in enums section
  title: string;
  body: string;
  // is option is enabled as a feature or not (like SMS is disabled in first release)
  featureEnabled: boolean;
  isActive: boolean; // indicates if me as employee has enabled this for me
}
interface SetEmployeeSettingsRequest {
  activeSettingIds: string[];
}
interface GetUnreadCountResponse {
  employeeId: string;
  unreadCount: number;
  sentCount: number;
}
interface GetAllNotificationsRequest {
  page: number;
  size: number;
}
interface GetAllNotificationsResponse {
  page: string;
  size: string;
  total: number;
  items: NotificationV2[];
}
export type NotificationV2={
  // id: number;
  // module: string;
  // event: string;
  // title: string;
  // body: string;
  // channel: NotificationChannels;
  // createdAt: Date;
  // updatedAt: Date;
  // employeeId: string;
  id: string;
  module: string;
  event: string;
  channel: NotificationChannels;
  title: string;
  body: string;
  isRead: boolean;
  createdAt: string;
}
// New notification queries
export const useGetNotificationSettingsQuery = (options?: {
  enabled?: boolean;
}) => {
  return useQuery<
    NotificationsResponse,
    { error: { message: string } },
    NotificationsResponse
  >(
    ['get-notification-settings'],
    async () =>
      await NotificationSettingsAPI.getter(
        NotificationsAPI.getNotificationSettings(),
      ),
    {
      staleTime: 10 * 1000,
      refetchOnWindowFocus: false,
      enabled: options?.enabled !== false,
    },
  );
};

export const useSetNotificationSettingsMutation = () => {
  return useMutation<
    { message: string },
    { error: { message: string } },
    SetEmployeeSettingsRequest
  >((data) =>
    NotificationSettingsAPI.putter(
      NotificationsAPI.setNotificationSettings(),
      data,
    ),
  );
};

export const useGetUnreadCountQuery = () => {
  return useQuery<
    GetUnreadCountResponse,
    { error: { message: string } },
    GetUnreadCountResponse
  >(
    ['get-unread-count'],
    async () =>
      await NotificationSettingsAPI.getter(NotificationsAPI.getUnreadCount()),
    // {
    //   staleTime: 5 * 1000,
    //   refetchOnWindowFocus: true,
    //   refetchInterval: 30 * 1000, // Refetch every 30 seconds
    // },
  );
};

export const useGetAllNotificationsQuery = (
  params: GetAllNotificationsRequest,
) => {
  const { page, size } = params;
  return useQuery<
    GetAllNotificationsResponse,
    { error: { message: string } },
    GetAllNotificationsResponse
  >(
    ['get-all-notifications', page, size],
    async () =>
      await NotificationSettingsAPI.getter(
        NotificationsAPI.getAllNotifications(params),
      ),
    {
      staleTime: 10 * 1000,
      refetchOnWindowFocus: 'always',
    },
  );
};
export const useMarkAllNotificationsAsRead = () => {
  return useMutation<{ message: string }, { error: { message: string } }, void>(
    () => NotificationSettingsAPI.putter(NotificationsAPI.markAllAsRead()),
  );
};
